module.exports = __webpack_public_path__ + "img/doctor.b4ee1c6e.svg";